
import { Button, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import styles from "./list.module.css";
import axios from "axios";
import { forwardRef, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { authData } from "../../components/GetAuth";

const CustomInput = forwardRef((props, ref) => (
  <TextField
    {...props}
    inputRef={ref}
    id="outlined-basic"
    label="Price(&pound;)*"
    variant="outlined"
  />
));
const CustomDiscountInput = forwardRef((props, ref) => (
  <TextField
    {...props}
    inputRef={ref}
    id="outlined-basic"
    label="Discount(%)*"
    variant="outlined"
  />
));

const durationList = [
  { value: "1 month", label: "1 month" },
  { value: "3 months", label: "3 months" },
  { value: "6 months", label: "6 months" },
  { value: "12 months", label: "12 months" },
];
const AddMembershipForm = ({
  setFormOpen,
  setAllData,
  setSnackbarOpen,
  setSnackbarMessage,
  setSnackbarType,
  setLoading,
  editData,
}) => {
  const auth = authData();
  const API_TOKEN = auth?.api_token;

  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      name: "",
      duration: "",
      price: "",
      discount: "",
    },
  });

  useEffect(() => {
    if (editData) {
      setValue("name", editData?.name);
      setValue("duration", editData?.duration);
      setValue("price", editData?.price);
      setValue("discount", editData?.discount);
      //setValue("yearly_amount", editData?.yearly_amount);
    }
  }, [editData, setValue]);

  const onSubmit = (data) => {
    data.yearly_amount = 0;
    setLoading(true);
    setFormOpen(false);
    if (editData) {
      axios
        .post(
          process.env.REACT_APP_API_URL + "v1/memberships/" + editData?.id,
          data,
          {
            headers: {
              Authorization: `Bearer ${API_TOKEN}`,
            },
          }
        )
        .then((response) => {
          setLoading(false);
          if (response.data.status === "SUCCESS") {
            setSnackbarOpen(true);
            setSnackbarMessage(response.data.message);
            setSnackbarType("success");
            setAllData((prev) => {
              let temp = prev.map((i) => {
                if (i.id === editData?.id) {
                  return response.data.data;
                }
                return i;
              });
              return temp;
            });
          }
          if (response.data.status === "ERROR") {
            setSnackbarOpen(true);
            setSnackbarMessage(response.data.message);
            setSnackbarType("error");
          }
        })
        .catch((error) => {
          setLoading(false);
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.messages
          ) {
            setSnackbarOpen(true);
            setSnackbarMessage(error.response.data.messages);
            setSnackbarType("error");
          }
        });
    } else {
      axios
        .post(process.env.REACT_APP_API_URL + "v1/memberships", data, {
          headers: {
            Authorization: `Bearer ${API_TOKEN}`,
          },
        })
        .then((response) => {
          setLoading(false);
          if (response.data.status === "SUCCESS") {
            setSnackbarOpen(true);
            setSnackbarMessage(response.data.message);
            setSnackbarType("success");
            setAllData((prev) => {
              return [response.data.data].concat(prev);
            });
          }
          if (response.data.status === "ERROR") {
            setSnackbarOpen(true);
            setSnackbarMessage(response.data.message);
            setSnackbarType("error");
          }
        })
        .catch((error) => {
          setLoading(false);
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.messages
          ) {
            setSnackbarOpen(true);
            setSnackbarMessage(error.response.data.messages);
            setSnackbarType("error");
          }
        });
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className={`${styles.FormMainRow}`}>
        <div className={`${styles.FormGroupFull} FormGroup`}>
          <Controller
            control={control}
            {...register("name", { required: "This field is Required" })}
            render={({ field }) => (
              <TextField {...field} label="Name*" variant="outlined" />
            )}
          />
          {errors.name && (
            <span className={`ErrorM`}>{errors?.name?.message}</span>
          )}
        </div>
        <div className={`${styles.FormGroupFull} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Duration*</InputLabel>
            <Controller
              control={control}
              {...register("duration", {
                required: "This field is Required",
              })}
              render={({ field }) => (<Select label="Duration*" {...field}>
                {durationList?.map((i) => {
                  return (<MenuItem key={i?.value} value={i?.value}>{i?.label}</MenuItem>);
                })}
              </Select>)}
            />
          </FormControl>
          {errors.duration && (
            <span className={`ErrorM`}>{errors?.duration?.message}</span>
          )}
        </div>
        <div className={`${styles.FormGroupFull} FormGroup`}>
          <Controller
            control={control}
            {...register("price", {
              required: "This field is Required",
            })}
            render={({ field }) => (
              <NumericFormat
                {...field}
                customInput={CustomInput}
                decimalScale={2}
              />
            )}
          />

          {errors.price && (
            <span className={`ErrorM`}>{errors?.price?.message}</span>
          )}
        </div>
        <div className={`${styles.FormGroupFull} FormGroup`}>
          <Controller
            control={control}
            {...register("discount", {
              required: "This field is Required",
            })}
            render={({ field }) => (
              <NumericFormat
                {...field}
                customInput={CustomDiscountInput}
                decimalScale={2}
              />
            )}
          />

          {errors.discount && (
            <span className={`ErrorM`}>{errors?.discount?.message}</span>
          )}
        </div>
      </div>
      <div className="ButtonAction">
        <Button className="CancelPopupBU" onClick={(e) => setFormOpen(false)}>
          Cancel
        </Button>
        <Button className="SubmitPopupBU" type="submit">
          {editData ? "Update" : "Add"}
        </Button>
      </div>
    </form>
  );
};

export default AddMembershipForm;
